import * as yup from 'yup';

export const userChangePasswordSchema = yup.object({ 
  newPassword: yup.string()
                  .required('Contraseña es requerida')
                  .min(8, 'Mínimo 8 caracteres')
                  .matches(/[a-z]/, 'Debe contener al menos una minúscula')
                  .matches(/[A-Z]/, 'Debe contener al menos una mayúscula')
                  .matches(/[0-9]/, 'Debe contener al menos un número')
                  .matches(/[\W_]/, 'Debe contener al menos un carácter especial'),
  confirmPassword: yup.string()
                  .required('Confirmar contraseña es requerido')
                  .oneOf([yup.ref('newPassword'), null as any], 'Las contraseñas no coinciden')
});